import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetAllCompDataError,
  GetAllCompDataVariables,
  fetchGetAllCompData,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getAllCompData;

export function useGetAllCompData(
  variables: GetAllCompDataVariables,
  opts?: UseQueryOptions<Response, GetAllCompDataError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetAllCompDataError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/attachments/compdata',
      operationId: 'getAllCompData',
      variables,
    }),
    async () => {
      const res = await fetchGetAllCompData({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
